module.exports = __webpack_public_path__ + "img/379.c14b92b5.png";